export default {
  FETCHED_ALL: 'FETCHED_ALL_ORGANISATIONS',
  FETCHED_MULTIPLE: 'FETCHED_ORGANISATIONS',
  FETCHED_SINGLE: 'FETCHED_ORGANISATION',
};
